import React from "react"
import connect from "./connect"
import QuickLink from "../BurgerQuickLink"
import {QUICKLINK_TYPE, BURGER_QUICKLINK_TYPE} from "../../config/constants"

export type FavouritesProps = {
    smallIconUrl: string
    altText: string
    enableFavourites: boolean
    hasFavourites: boolean
    favouritesUrl: string
    title: string
    description: string
}

export const BurgerFavourites = ({
    smallIconUrl,
    altText,
    enableFavourites,
    hasFavourites,
    favouritesUrl,
    title,
    description,
}: FavouritesProps) => {
    if (!enableFavourites || !title) return null
    return (
        <QuickLink
            href={favouritesUrl}
            iconSrc={smallIconUrl}
            iconAltText={altText}
            title={title}
            description={description}
            type={QUICKLINK_TYPE.LINK}
            linkType={BURGER_QUICKLINK_TYPE.FAVOURITES}
            hideBadge={!hasFavourites}
        />
    )
}

export default connect(BurgerFavourites)
